export default "__VITE_ASSET__CSyGYOAa__"